export const zh = {
  header: { title: "走向全球。每条短视频 2 美元。支持任何语言！", subtitle: "🔥仅为结果付费 – 每秒从$0.089到$0.009🔥" },
  steps: { uploadVideo: "上传视频", selectLanguages: "选择语言", conversionResult: "转换和结果" },
  upload: { dragAndDrop: "将您的视频文件拖放到这里", orClickToSelect: "或点击选择", supportedFormats: "支持的格式：MP4、AVI、MOV、MKV、WebM", maxFileSize: "• 最大文件大小：200 MB", maxDuration: "• 最大时长：30秒", processingTime: "• 处理时间为2到15分钟，取决于视频分辨率", chooseFile: "选择文件", selectedFile: "已选择文件：", size: "大小：", fileTypeError: "请选择视频文件", fileSizeError: "文件大小（{size} MB）超过200 MB的最大限制", durationError: "视频时长（{duration}秒）超过30秒的最大限制", fileReadError: "无法读取视频文件。请尝试其他文件。" },
  languages: { sourceAudioLanguage: "源音频语言", targetAudioLanguage: "目标音频语言", selectLanguage: "选择语言..." },
  languageOptions: { ru: "俄语", en: "英语", es: "西班牙语", fr: "法语", de: "德语", it: "意大利语", pt: "葡萄牙语", pl: "波兰语", zh: "中文", ja: "日语", ko: "韩语" },
  conversion: { replaceAudio: "克隆我的声音", uploadVideoAndSelectLanguages: "上传视频并选择语言以继续", fixValidationError: "请修复上面的文件验证错误", createSubtitles: "创建字幕", uploadVideoForSubtitles: "上传视频以创建字幕", selectTranslationLanguage: "选择翻译语言" },
  demo: { seeVeviInAction: "观看VEVI实际操作", watchHowItWorks: "观看我们的AI语音替换技术如何工作", beforeEnglish: "之前（英语）", originalPresentation: "原始企业演示", afterSpanish: "之后（西班牙语,法语,中文,意大利语）", aiTranslatedVoice: "AI翻译配自然语音", demoTitle: "演示 - VEVI实际操作" },
  reviews: { title: "客户评价", subtitle: "受到全球营销专业人士的信赖", customerReviews: [{ name: "莎拉·约翰逊", position: "数字营销经理", company: "TechFlow Solutions", text: "VEVI改变了我们的国际营销活动！" }, { name: "迈克尔·陈", position: "内容营销总监", company: "GlobalReach Media", text: "作为管理多个地区视频内容的人，VEVI是游戏规则的改变者。" }, { name: "艾玛·罗德里格斯", position: "品牌营销专员", company: "InnovateCorp", text: "我们在扩展到新市场时节省了数千美元的配音成本。" }, { name: "大卫·汤普森", position: "营销活动经理", company: "NextGen Brands", text: "VEVI的速度和质量无与伦比。" }, { name: "丽莎·帕克", position: "社交媒体营销负责人", company: "CreativeEdge Agency", text: "VEVI使我们的小型代理机构能够为客户提供多语言视频服务。" }, { name: "詹姆斯·威尔逊", position: "绩效营销总监", company: "ScaleUp Ventures", text: "ROI在绩效营销中至关重要，而VEVI能够实现。" }] },
  payment: { title: "转换付款", processingCost: "处理费用", duration: "时长：", baseCost: "基本费用", discount: "折扣（{promoCode}）：", discountAmount: "折扣金额：", total: "总计：", emailToReceiveResult: "接收结果的邮箱", emailPlaceholder: "your-email@example.com", promoCode: "🎟️ 促销代码（可选）", promoCodePlaceholder: "输入促销代码", check: "验证", checking: "验证中...", addSubtitles: "为视频添加字幕", addSubtitlesDescription: "生成并嵌入目标语言的字幕", highQualityTranslation: "• 高质量AI翻译", originalVideoPreserved: "• 保留原始视频", fastProcessing: "• 快速处理（通常5-10分钟）", resultWillBeSent: "• 结果将发送到指定邮箱", cancel: "取消", continue: "继续", enterEmail: "请输入您的邮箱", enterValidEmail: "请输入有效的邮箱地址", enterPromoCode: "请输入促销代码", invalidPromoCode: "无效的促销代码", validPromoCode: "有效的促销代码！已应用{discount}%折扣" },
  progress: { title: "处理视频中", uploadingAndExtracting: "🎬 上传并提取音频", transcribingAndTranslating: "🗣️ 转录语音并翻译", synthesizingAudio: "🎵 合成新音频轨道", step: "步骤：", error: "错误" },
  result: { title: "完成！您的视频已处理", conversionCompleted: "转换成功完成！", processedVideoDescription: "🎬 您的已处理视频配语音克隆", payAndDownload: "付款并下载", videoNotAvailable: "视频不可用", useDownloadButton: "请使用下方的下载按钮", downloadError: "下载错误" },
  emailSent: { title: "视频已发送！🎉", videoOnWay: "视频已在发送到您的邮箱的路上🙏❤️", checkInbox: "请检查您的收件箱和垃圾邮件文件夹。处理后的视频很快就会到达！", whatsNext: "接下来做什么？", checkEmail: "• 检查您的邮箱（{email}）", checkSpam: "• 如果没找到，请查看垃圾邮件文件夹", downloadAndEnjoy: "• 下载并享受您的配音视频！", close: "关闭", processAnotherVideo: "处理另一个视频" },
  processingSteps: { uploading: "上传视频中...", extracting: "提取音频中...", transcribing: "转录语音中...", translating: "翻译内容中...", synthesizing: "合成新语音中...", rendering: "渲染最终视频中...", complete: "处理完成！" },
  common: { minutes: "分钟", seconds: "秒", loading: "加载中...", error: "错误", success: "成功" },
  socialMedia: {
    title: "保持联系",
    description: "获取有关AI语音技术的最新更新"
  },

  // Services (for Footer)
  services: {
    dubbing: "配音",
    voiceClone: "语音克隆配音",
    newVoice: "新语音配音",
    multilingual: "多语言配音",
    multiSpeaker: "多说话者配音",
    subtitles: "字幕",
    subtitlesOnly: "仅字幕",
    multilingualSubtitles: "多语言字幕",
    subtitlesDescription: "自动为任何平台生成准确的字幕。",
    subtitlesPrice: "处理费用: $0.01/秒",
    addSubtitles: "添加字幕",
    needsTranslation: "需要翻译吗？",
    translationLanguage: "翻译语言"
  },

  // Footer
  footer: {
    legal: "法律信息",
    privacyPolicy: "隐私政策",
    termsOfUse: "使用条款"
  },

  // Navigation
  nav: {
    blog: "博客"
  },

  // Blog (using English content as fallback)
  blog: {
    title: "VEVI Monster 博客",
    subtitle: "VEVI宇宙的历史与神话",
    readMore: "阅读更多",
    backToBlog: "返回博客",
    articleNotFound: "未找到文章",
    characteristics: "特征",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi是诞生于Zera-13b等离子漩涡的存在。他既不是血肉也不是金属—他的身体由电磁场聚集在一起的振动粒子组成。",
        metadata: {
          "星系": "MoM-z14",
          "年龄": "134亿年",
          "类型": "具有甲烷和氖的稠密大气的岩石行星",
          "恒星": "红色原恒星Zera-13",
          "轨道": "系统中的第二颗行星",
        },
        content: [
          "🌑 描述",
          "Zera-13b是一个古老且几乎被遗忘的世界，诞生于宇宙刚刚学会发光的时代。",
          "它的天空闪烁着暗淡的绿色火焰，稠密的大气因氖风暴而颤抖。表面是黑色灰色的景观，覆盖着玻璃状的陨石坑，甲烷风在空气中留下火焰痕迹。",
          "表面下方是冰冻气体的洞穴，根据传说，第一批能够思考的能量形式在这里诞生。",
          "👾 Vevi (Vevi Monster)",
          "Vevi是诞生于Zera-13b等离子漩涡的存在。",
          "他既不是血肉也不是金属—他的身体由电磁场聚集在一起的振动粒子组成。",
          "他的眼睛在恒星Zera-13的反射光中闪耀，他的声音听起来像氖风的低语。",
          "当原恒星开始消失时，Vevi离开了他的世界。他穿越了星系间的虚空，被寻找新能量的本能所引导。",
          "现在他漫游于各个世界，携带着Zera-13b原始光的一部分。",
          "光芒来自行星",
          "他没有腿—因为行星有巨大的重力，他只是漂浮着",
          "他交流（或更确切地说是发出声音）类似于海豚、鲸鱼和虎鲸的声波。",
          "他的语言被称为UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub是来自早期宇宙的存在，诞生于Sub Zone，一个具有高物质密度的稀有太空区域。",
        metadata: {
          "对象名称": "Sub Zone (SUB-Z)",
          "对象类型": "原星团 / 星系形成区域",
          "时代": "大爆炸后约2-3亿年",
          "红移": "z ≈ 14–15",
          "赤经 (RA)": "02h 17m 43s",
          "赤纬 (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Baddy Sub数据",
          "长而细的椭圆形身体，底部有两个下肢，顶部延伸形式上有三只眼睛",
          "他没有嘴。",
          "还有两个上部的细肢，可以解释为手臂。",
          "每个肢上有两个手指。",
          "整个身体像树枝",
          "皮肤具有光滑的哑光结构",
          "颜色是绿褐色（色素沉着）",
          "可以像变色龙一样根据环境改变颜色。",
          "Baddy Sub出生的行星描述:",
          "Sub Zone是早期宇宙中具有高物质密度的稀有区域，第一批星系结构开始形成的地方。观测表明原始气体、辐射和引力波之间存在强烈的相互作用。该区域记录了不稳定的信号模式和异常共振活动，这不是典型原星系区域的特征。",
          "科学意义:",
          "Sub Zone被认为是研究星系组装的早期阶段、年轻宇宙中的信号传播以及从混沌辐射场到结构化宇宙系统转变的关键对象。",
          "状态:",
          "被归类为未解决的形成区域。需要进一步研究。",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "常见问题",
    subtitle: "关于VEVI您需要了解的一切",
    questions: [
      {
        question: "你们只处理语音吗？",
        answer: "是的 — 我们替换您的语音，使其在另一种语言中听起来自然而真实。"
      },
      {
        question: "我是在之前还是之后付款？",
        answer: "之后。您先听结果，然后再付款。"
      },
      {
        question: "退款？",
        answer: "不需要 — 您只有在满意结果后才付款。"
      },
      {
        question: "视频超过10分钟？",
        answer: "没问题。在在线聊天中询问我们的AI助手获取说明。"
      },
      {
        question: "我可以选择其他语音吗？",
        answer: "不可以 — 我们只克隆您自己的语音。"
      },
      {
        question: "最低付款？",
        answer: "从$0.50起。"
      },
      {
        question: "我如何获得我的视频？",
        answer: "在浏览器中即时下载 + 付款后发送到您的电子邮件。"
      },
      {
        question: "大订单折扣？",
        answer: "是的 — 在在线聊天中联系我们的AI助手。"
      },
      {
        question: "没找到答案？",
        answer: "在在线聊天中询问我们的AI助手 — 我们随时为您提供帮助。"
      },
      {
        question: "不支持的格式？",
        answer: "使用转换器或从我们的在线聊天AI助手获得快速帮助。"
      },
      {
        question: "我的视频包含必须正确发音的特定术语。我可以控制吗？",
        answer: "是的 — 只需在在线聊天中向我们的AI助手发送消息，我们将向您发送有关如何标记或保留某些术语的说明（例如，将它们保留为英文）。"
      },
      {
        question: "我没有收到电子邮件。我该怎么办？",
        answer: "由于队列量的原因，处理时间可能会有所不同。别担心 — 您的文件是安全的。一旦准备好，您将收到通知或直接下载链接。"
      }
    ]
  }
};
